export default __webpack_public_path__ + "static/0120-2b35193c14c3684b8568921776d8f969.png";